import { useLayoutEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { useTimelineContext } from 'context/TimelineContext'
import { eventBus, EVENT_TYPES } from 'services/event-bus'

const useCorrectPlayheadTimeOnDurationChange = () => {
  const prevDurationRef = useRef(0)
  const projectDuration = useSelector(projectDataSelectors.duration)
  const {
    isPlaying,
    playHeadRef,
    getCurrentTimeImmediate,
    setPlayHeadCurrentTime,
    onPause,
    onPlay
  } = useTimelineContext()

  useLayoutEffect(() => {
    if (!playHeadRef.current) return
    const prevDuration = prevDurationRef.current

    if (!prevDuration) {
      prevDurationRef.current = projectDuration
      return
    }

    isPlaying && onPause()

    const durationRatio = projectDuration / prevDuration
    const currentTime = getCurrentTimeImmediate()
    const correctTime = durationRatio ? currentTime / durationRatio : 0

    setPlayHeadCurrentTime(correctTime)
    isPlaying && onPlay()
    eventBus.publish(EVENT_TYPES.PLAYBACK_TIME_CHANGE, correctTime)

    prevDurationRef.current = projectDuration

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDuration])
}

export default useCorrectPlayheadTimeOnDurationChange
